import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/extModule.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';

const defaultFormData = {
  name: '',
  title: '',
  git: '',
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  defaultProps({
    getImage: ModelService.getImage,
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
    },
  }),
  withProps(props => ({
    title: props.t('Ext module') + fh.getTitleEnd(props),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/extModules/item/index.js